import React from 'react'
import ReactDOM from 'react-dom/client'
import { Analytics } from '@vercel/analytics/react'
import App from './App.jsx'
import './index.css'
import './i18n'
import { isEnProductionHost } from './utils/enGa'
import { syncSiteSeoHead } from './utils/siteSeo'

syncSiteSeoHead()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
    {isEnProductionHost() ? <Analytics /> : null}
  </React.StrictMode>,
)
